import { theme } from "antd";

import type { AppShadowTokens } from "./shadows";
import type { AppBrandTokens, AppGrayTokens, AppNeutralTokens } from "./palette";

// Читаем текущий ConfigProvider, включая вложенные превью другой темы в ThemeLab.
export const useAppToken = () => {
  const result = theme.useToken();
  return {
    ...result,
    token: result.token as typeof result.token & AppBrandTokens & AppGrayTokens & AppNeutralTokens & AppShadowTokens,
  };
};
